export const ORGANIZATION_KEY_ALREADY_EXISTS_MESSAGE =
  "Organization key already exists";

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return "";
}

export function isOrganizationKeyDuplicateError(error: unknown): boolean {
  const normalized = getErrorMessage(error).toLowerCase();
  return (
    normalized.includes("duplicate") || normalized.includes("already exists")
  );
}
